import { useTranslation } from "react-i18next";

export default function GuestReviews() {
  const { t } = useTranslation();

  const reviews = [
    {
      text: t("review_1_text"),
      author: t("review_1_author"),
    },
    {
      text: t("review_2_text"),
      author: t("review_2_author"),
    },
    {
      text: t("review_3_text"),
      author: t("review_3_author"),
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight mb-8">
            {t("reviews_title")}
          </h2>

          <div className="inline-flex flex-col items-center gap-3 px-6 py-5 rounded-lg bg-background-50 border border-background-200">
            <div className="flex items-center gap-2">
              <i className="ri-google-fill text-xl text-foreground-950"></i>
              <span className="text-sm font-medium text-foreground-700">
                {t("reviews_google_label")}
              </span>
            </div>
            <div className="flex items-end gap-2">
              <span className="font-heading text-4xl leading-none text-foreground-950">
                4.7
              </span>
              <span className="font-heading text-lg text-foreground-600 mb-0.5">
                / 5
              </span>
            </div>
            <div className="flex items-center justify-center gap-1 text-accent-700 text-lg">
              {[0, 1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600">
              {t("reviews_rating_based")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <figure
              key={review.author}
              className="bg-background-50 border border-background-200 rounded-lg p-8 flex flex-col items-center text-center"
            >
              <div className="flex items-center justify-center gap-1 text-accent-700 text-base mb-4">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <blockquote className="text-foreground-900 leading-relaxed font-medium text-lg">
                „{review.text}“
              </blockquote>
              <figcaption className="mt-5 text-sm text-foreground-600">
                — {review.author}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}